<template>
  <div>
    <!-- Page content -->
    <section class="py-6">
      <b-container>
          <b-row align-v="center" class="content-center actus shadow">
            <b-col lg="6" class="pl-lg-6">
              <b-row>
                <b-col lg="12" class="pb-4 pb-lg-0 order-2 order-lg-1">
                  <h2 class="h2 font-weight-900 d-none d-lg-block">{{ $t('actus.blog.title') }}</h2>
                  <b-row class="pt-lg-4" align-v="center">
                    <b-col cols="2" lg="2">
                      <i class="icon"><a :href="data.actus.blog.url" target="_blank"><b-img class="" alt="..." src="./img/theme/actus/blog.png" /></a></i>
                    </b-col> 
                    <b-col cols="10" lg="10">
                      <span class="h2 font-weight-900 mb-0 d-block d-lg-none" v-html="$t('actus.blog.title')"></span>
                      <p v-html="$t('actus.blog.description')"></p>
                    </b-col>
                  </b-row>                 
                </b-col>

                <b-col lg="12" class="pt-lg-5 pt-3 pb-5 pb-lg-0 order-1 order-lg-2">
                  <h2 class="h2 font-weight-900">{{ $t('actus.follow.title') }}</h2>
                  <div class="pt-lg-4">
                    <i class="icon"><a :href="data.actus.networks.instagram" target="_blank"><b-img class="" alt="..." src="./img/theme/actus/instagram.png" /></a></i>
                    <i class="icon"><a :href="data.actus.networks.twitter" target="_blank"><b-img class="" alt="..." src="./img/theme/actus/twitter.png" /></a></i>
                    <i class="icon"><a :href="data.actus.networks.linkedin" target="_blank"><b-img class="" alt="..." src="./img/theme/actus/linkedin.png" /></a></i>
                    <i class="icon"><a :href="data.actus.networks.facebook" target="_blank"><b-img class="" alt="..." src="./img/theme/actus/facebook.png" /></a></i>
                  </div>                  
                </b-col>
              </b-row>              
            </b-col>
            <b-col lg="6" align-v="center">
              <div class="mt-3">
                <b-carousel
                    :interval="15000"                   
                    indicators
                    controls
                    background="white"
                    img-width="1024"
                    img-height="480"
                  >

                  <b-carousel-slide :key="item.id" v-for="item in slides">
                    <b-link :href="item.carousellangs[0].cln_url" target="_blank">
                      <div class="carousel-image" :style="{ backgroundImage: 'url(' + encodeURI(imageBaseUrl + item.carousellangs[0].cln_image) + ')' }"></div>                    
                    </b-link>
                    <p v-html="item.carousellangs[0].cln_title"></p>
                  </b-carousel-slide>

                </b-carousel>
              </div>
            </b-col>            
          </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import data from '../../../datas';
import { mapActions } from "vuex";
export default {
  name: 'Actus',

  data() {
    this.loadCarousels();
    return {
      data,
      slideInterval: process.env.VUE_APP_SLIDEINTERVAL,
      imageBaseUrl: process.env.VUE_APP_APIURL + "image/",
      slides: []
    }
  },
  methods: {
    ...mapActions(["GetCarouselsToPublish"]),
    async loadCarousels() {
      //let lan = localStorage.getItem(Vue.Keys.LANGUAGE);
      let lan = Vue.i18n.locale();
      await this.GetCarouselsToPublish(lan);
      this.slides = this.$store.getters.Carousels
    }
  }
};
</script>
